import React from 'react';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';

function WindowResizeHandler(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.debouncedResizeHandler = debounce(this.debouncedResizeHandler.bind(this), 300);
            this.throttledScrollHandler = throttle(this.throttledScrollHandler.bind(this), 200);
        }

        componentDidMount() {
            window.addEventListener('scroll', this.throttledScrollHandler);
            window.addEventListener('resize', this.debouncedResizeHandler);
            window.addEventListener('orientationchange', this.debouncedResizeHandler);

            this.debouncedResizeHandler(); //  Go ahead and upate the size.
        }

        debouncedResizeHandler() {
            this.props.actions.windowSizeChanged(
                window.innerHeight,
                window.innerWidth,
                window.scrollY
            );
        }

        throttledScrollHandler() {
            this.props.actions.windowScrolled(window.scrollY || 0);
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

export default WindowResizeHandler;
